<template>
  <div class="index_background" style="padding: 20px">
    <el-form :model="form" label-width="120" :rules="rules" ref="form">
      <h5 align="center">合同签署平台登录</h5>
      <el-form-item label="登录账号" prop="username">
        <el-input v-model="form.username" placeholder="请输入登录账号"></el-input>
      </el-form-item>
      <el-form-item label="密码" prop="password">
        <el-input v-model="form.password" type="password" placeholder="请输入6-16位数字字母、特殊字符组合（区分大小写）"></el-input>
      </el-form-item>

      <el-form-item label="验证码" prop="vcode">
        <el-input v-model="form.vcode"></el-input>
        <img id="verImg" :src="vcode_img" width="130px" height="48px" />
        <a class="refreshCode" @click="refreshCode()" style="color:red">看不清?换一张</a>
        <!-- <span class="resetPwd"><router-link @click="refreshCode()" style="color:red">看不清?换一张</router-link></span> -->
      </el-form-item>

      <el-form-item align="center"> <el-button type="primary" @click="login('form')">登录</el-button> </el-form-item>
      <span class="register"><router-link :to="{ path: '/register' }">没有账号？去注册</router-link></span>
      <span class="resetPwd"><router-link :to="{ path: '/resetPwd' }">忘记密码？去找回</router-link></span>
    </el-form>
  </div>
</template>

<script>
import { loginApi } from '@/api/getData.js'
import { getmenuApi } from '@/api/getData.js'
import { makeCodeApi } from '@/api/getData.js'
//import SIdentify from '../../components/IdentifyCode'
import md5 from 'js-md5'
import { encrypt } from '@/utils/jsencrypt.js'

//import { checkVCodeApi } from '@/api/getData.js'

export default {
  components: {
    //SIdentify
  },
  data() {
    //前台取消验证码验证，交给后台验证
    // var validateVcode = (rule, value, callback) => {
    //   if (value != this.identifyCode) {
    //     callback(new Error('验证码错误！'))
    //   } else {
    //     callback()
    //   }
    // }
    return {
      identifyCode: '',
      vcode_img: '',
      verKey: '',
      form: {
        username: '',
        password: '',
        vcode: ''
      },
      rules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          { min: 6, max: 11, message: '长度6-11个字符', trigger: 'blur' }
        ],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
        //vcode: [{ required: true, validator: validateVcode, trigger: 'change' }]
      }
    }
  },
  methods: {
    login(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          var salt = this.form.username.substring(2, 6)
          //console.info(md5(salt + this.form.password + salt).toUpperCase())
          var password = md5(salt + this.form.password + salt).toUpperCase()
          //console.info(md5(salt + password + salt).toUpperCase())
          // 需要RSA加密
          let rsapwd = encrypt(password)
          //console.info('RAS加密后：' + rsapwd)

          //调用登录接口
          loginApi(this.form.username, rsapwd, this.form.vcode, this.verKey).then(res => {
            if (res.data.code === 0) {
              this.$store.commit('clearMenu')
              this.$store.commit('setToken', res.data.data.session_id)
              this.$store.commit('addMenu', this.$router)
              this.getMenu()
              this.$router.push({ name: 'home' })
            } else {
              this.$message.warning(res.data.msg)
              this.refreshCode()
            }
          })
        } else {
          this.refreshCode()
          this.$message({
            type: 'warning',
            message: '填写信息有误，请检查!'
          })
          return false
        }
      })
    },

    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min)
    },
    refreshCode() {
      makeCodeApi().then(res => {
        //console.info(res.data)
        this.vcode_img = res.data.data
        this.verKey = res.data.msg
      })
    },

    //获取菜单
    getMenu() {
      getmenuApi().then(res => {
        if (res.data.code === 0) {
          this.$store.commit('setMenu', res.data.data)
        }
      })
    }
  },
  mounted() {
    //this.identifyCode = ''
    this.refreshCode()
  }
}
</script>

<style lang="scss" scoped>
.el-form {
  // width: 420px;
  // margin: auto;
  // padding: 45px;
  // margin-left: 1000px;
  // //text-align: center;
  // margin-top: 50px;
  // height: 550px;
  // background-color: #fff;
  // border-radius: 15px;

  position: absolute;
  width: 420px;
  height: 550px;
  padding: 45px;
  top: 10%;
  right: 5%;
  background-color: #fff;
  border-radius: 15px;
}

h5 {
  font-size: max($numbers: 25px);
}
.register {
  font-size: medium;
  color: blue;
  float: right;
}
.resetPwd {
  font-size: medium;
  color: blue;
  float: left;
}
.refreshCode {
  cursor: pointer;
}
.index_background {
  width: 100%;
  height: 100%;
  background-image: url('../../assets/images/background1.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  -moz-background-size: 100% 100%;
}
</style>
